var _defs, _path, _ellipse, _g, _rect, _rect2, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _g3, _g4, _g5, _path8, _path9, _path10, _path11, _g6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect3, _rect4, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadViewIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustartion_-_loadNewVersion",
    "data-name": "illustartion - loadNewVersion",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288.101,
    height: 204.704,
    viewBox: "0 0 288.101 204.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.68,
    y1: 0.515,
    x2: 1.791,
    y2: 0.515,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1ebfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#192280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b1e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.804,
    y1: 0.939,
    x2: 0.327,
    y2: 0.249,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M1514.427,2331.971c-2.891-12.59-8.816-16.863-14.07-25.236-6.418-10.227-10.7-17.628-7.728-29.8,4.861-19.887,10.616-70.041-38.223-67.7-17.505.84-32.468,14.3-43.7,28.059-9.56,11.708-24.877,11.472-37.385,13.3-15.367,2.247-31.176,6.291-45.8,12.963-30.117,13.743-40.746,36.36-42.214,66.361-.443,9.065-.543,23.394,11.788,41.252,16.643,24.1,43.443,29.483,76.93,22.018,7.665-1.709,15.04-4.8,22.621-6.944a95.088,95.088,0,0,1,24.07-3.594c18.887-.361,37.962,4.955,56.455.351a58.868,58.868,0,0,0,26.587-15A38.27,38.27,0,0,0,1514.427,2331.971Z",
    transform: "translate(-1272.335 -2209.161)",
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "dshadow",
    cx: 120.247,
    cy: 6.997,
    rx: 120.247,
    ry: 6.997,
    transform: "translate(5.972 190.71)",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gears",
    transform: "translate(3.68 3.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21531",
    "data-name": "Path 21531",
    d: "M396.478,1440.144a15.056,15.056,0,0,1,2.328,3.257l3.721-.014,1.383,5.977-3.352,1.611a14.991,14.991,0,0,1-.662,3.944l2.64,2.611-3.264,5.2-3.511-1.222a15.048,15.048,0,0,1-3.27,2.32l.014,3.708-6,1.378-1.617-3.339a15.147,15.147,0,0,1-3.959-.661l-2.619,2.631-5.221-3.252,1.227-3.5a15,15,0,0,1-2.328-3.257l-3.722.014-1.383-5.978,3.352-1.61a15.022,15.022,0,0,1,.662-3.944l-2.64-2.61,3.264-5.2,3.511,1.222a15.065,15.065,0,0,1,3.27-2.32l-.014-3.708,6-1.378,1.617,3.34a15.123,15.123,0,0,1,3.959.66l2.619-2.63,5.22,3.252-1.226,3.5Zm-7.342,4.893a6.587,6.587,0,1,0,2.1,9.068A6.619,6.619,0,0,0,389.136,1445.037Z",
    transform: "translate(-326.253 -1432.023)",
    fill: "#80beff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21532",
    "data-name": "Path 21532",
    d: "M261.919,1466.072a12.188,12.188,0,0,1,1.886,2.639l3.015-.011,1.12,4.843-2.715,1.3a12.159,12.159,0,0,1-.537,3.2l2.139,2.115-2.645,4.214-2.845-.99a12.2,12.2,0,0,1-2.649,1.88l.011,3-4.86,1.116-1.31-2.706a12.259,12.259,0,0,1-3.208-.535l-2.123,2.132-4.23-2.635.994-2.835a12.141,12.141,0,0,1-1.887-2.639l-3.016.011-1.12-4.843,2.716-1.3a12.15,12.15,0,0,1,.537-3.2l-2.139-2.115,2.645-4.214,2.845.99a12.192,12.192,0,0,1,2.649-1.88l-.012-3,4.86-1.116,1.31,2.706a12.277,12.277,0,0,1,3.207.535l2.123-2.131,4.229,2.635-.993,2.835Zm-5.949,3.965a5.337,5.337,0,1,0,1.7,7.347A5.363,5.363,0,0,0,255.97,1470.037Z",
    transform: "translate(-237.941 -1450.867)",
    fill: "#b9dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21530",
    "data-name": "Path 21530",
    d: "M323.845,1570.466a27.183,27.183,0,0,1,4.205,5.883l6.721-.026,2.5,10.8-6.053,2.909a27.063,27.063,0,0,1-1.2,7.124l4.769,4.715-5.9,9.393-6.342-2.206a27.2,27.2,0,0,1-5.905,4.19l.026,6.7-10.834,2.489-2.92-6.032a27.339,27.339,0,0,1-7.15-1.193l-4.732,4.752-9.429-5.875,2.216-6.319a27.1,27.1,0,0,1-4.205-5.883l-6.722.025-2.5-10.8,6.055-2.908a27.123,27.123,0,0,1,1.2-7.124l-4.768-4.715,5.9-9.394,6.342,2.208a27.188,27.188,0,0,1,5.905-4.191l-.026-6.7,10.834-2.489,2.92,6.032a27.336,27.336,0,0,1,7.15,1.193l4.732-4.752,9.428,5.874-2.214,6.32Zm-13.26,8.838a11.9,11.9,0,1,0,3.789,16.379A11.954,11.954,0,0,0,310.585,1579.3Z",
    transform: "translate(-260.169 -1516.938)",
    fill: "#4da4ff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pc_-_spaceship",
    "data-name": "pc - spaceship",
    transform: "translate(53.629 17.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computer",
    transform: "translate(0 54.514)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17216",
    "data-name": "Rectangle 17216",
    width: 42.952,
    height: 11.513,
    transform: "translate(52.746 102.977)",
    fill: "#21397d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17217",
    "data-name": "Rectangle 17217",
    width: 148.899,
    height: 106.735,
    rx: 9.789,
    fill: "#457cdd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17218",
    "data-name": "Rectangle 17218",
    d: "M5.924,0H134.2a5.924,5.924,0,0,1,5.924,5.924v78.02A5.925,5.925,0,0,1,134.2,89.87H5.924A5.924,5.924,0,0,1,0,83.945V5.924A5.924,5.924,0,0,1,5.924,0Z",
    transform: "translate(4.159 6.625)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17219",
    "data-name": "Rectangle 17219",
    d: "M7.258,0H72.618a7.258,7.258,0,0,1,7.258,7.258v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A7.258,7.258,0,0,1,7.258,0Z",
    transform: "translate(34.284 113.488)",
    fill: "#457cdd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21555",
    "data-name": "Path 21555",
    d: "M-8319.347-1262.009a.325.325,0,0,0-.325.324v89.372a.326.326,0,0,0,.325.325h40.047l90.351-90.022Z",
    transform: "translate(8324.579 1268.482)",
    opacity: 0.446,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "spaceship",
    transform: "translate(4.159 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clouds",
    transform: "translate(0 61.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17318",
    "data-name": "Group 17318",
    transform: "translate(39.155 3.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21211",
    "data-name": "Path 21211",
    d: "M-597.341-647.568c-9.821,22.679-2.409,40.756-2.409,40.756l-10.052,1-6.551.648c-7.548-36.031,22.8-60.312,23.012-60.48-15.583,22.023-12.863,43.717-12.863,43.717C-606.394-632.858-597.479-647.344-597.341-647.568Z",
    transform: "translate(617.559 665.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21212",
    "data-name": "Path 21212",
    d: "M-609.8-605.816l-6.551.648c-7.548-36.031,22.8-60.312,23.012-60.48-.155.193-20.015,24.834-20.252,41.715C-613.732-614.185-611.621-608.71-609.8-605.816Z",
    transform: "translate(617.559 665.648)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17320",
    "data-name": "Group 17320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17319",
    "data-name": "Group 17319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21213",
    "data-name": "Path 21213",
    d: "M-551.932-595.507a10.58,10.58,0,0,0-3.606.635,17.25,17.25,0,0,0-10.009-10.61c-.093-.036-.187-.069-.284-.1-.057-.018-.111-.037-.163-.054a13.565,13.565,0,0,0-4.131-.645,13.624,13.624,0,0,0-2.35.205c-1.6-3.873-4.938-6.537-8.8-6.537a8.267,8.267,0,0,0-1.571.15,9.644,9.644,0,0,0-6.146,4.33,14.369,14.369,0,0,0-4.03-.578c-.178,0-.355.005-.531.012-3.08-4.969-8.029-8.191-13.608-8.191a15.176,15.176,0,0,0-10.278,4.151,19.718,19.718,0,0,0-4.612,6.44,15.29,15.29,0,0,0-3.331-1.623,14.17,14.17,0,0,0-2.013-.536,14.268,14.268,0,0,0-2.683-.253,14.466,14.466,0,0,0-5.737,1.191q-.641.276-1.256.609a19.916,19.916,0,0,0-4.914-7.2,16.82,16.82,0,0,0-1.976-1.569v-.094q0-1.181-.111-2.329a23.2,23.2,0,0,0-.6-3.486v0c-.013-.057-.027-.111-.041-.168l0,0a19.711,19.711,0,0,0-8.424-11.952,14.919,14.919,0,0,0-5.364-2.03h0a14.315,14.315,0,0,0-2.365-.2,14.308,14.308,0,0,0-4.445.706,14.907,14.907,0,0,0-2.671,1.161,11.638,11.638,0,0,0-5.965-4.037q.387-.771.711-1.59.162-.409.307-.829c.064-.186.127-.373.186-.562.089-.285.172-.572.25-.862.047-.18.094-.361.136-.543a21.52,21.52,0,0,0,.578-4.987,21.462,21.462,0,0,0-.771-5.737,19.942,19.942,0,0,0-.917-2.606c-.035-.083-.071-.164-.11-.247h0v0c-.088-.195-.178-.389-.271-.581-.046-.1-.094-.193-.143-.288-.1-.188-.2-.375-.3-.56a17.919,17.919,0,0,0-1.921-2.827q-.274-.33-.561-.643h0a11.23,11.23,0,0,0,1.4-5.489,11.423,11.423,0,0,0-.064-1.223h-2.217a2.676,2.676,0,0,0-2.4,2.869v84.142a2.675,2.675,0,0,0,2.4,2.868h135.684a2.586,2.586,0,0,0,2.372-2.392v-2.4C-540.4-589.88-545.613-595.507-551.932-595.507Z",
    transform: "translate(680.075 667.688)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21214",
    "data-name": "Path 21214",
    d: "M-551.932-595.507a10.58,10.58,0,0,0-3.606.635,17.25,17.25,0,0,0-10.009-10.61c4.629,1.747,4.473,8.546.161,11.021a7.038,7.038,0,0,1-3.178.9c-7.346.372-8.541-2.884-8.541-2.884s-1.654,7.881-9,8.893a15.2,15.2,0,0,1-7.766-.887h0a14.3,14.3,0,0,1-5.456-3.733,20.944,20.944,0,0,1-7.411,5.011,18,18,0,0,1-9.385,1.124c-.628-.091-1.225-.2-1.793-.324-9.695-2.1-10.79-8.228-10.79-8.228-2.058,4.234-6.235,7.063-12.961,5.392s-7.773-6.877-7.773-6.877c-2.951,5.719-11.848,6.691-14.5,0s0-11.525,0-11.525c-4.365.371-8.8-8.4-5.757-17.466a12.255,12.255,0,0,1,6.728-7.738h0a17.286,17.286,0,0,1,9.821-.908,14.919,14.919,0,0,0-5.364-2.03h0a14.315,14.315,0,0,0-2.365-.2,14.308,14.308,0,0,0-4.445.706,14.907,14.907,0,0,0-2.671,1.161,11.638,11.638,0,0,0-5.965-4.037q.387-.771.711-1.59.162-.409.307-.829c.064-.186.127-.373.186-.562.089-.285.172-.572.25-.862.047-.18.094-.361.136-.543a21.52,21.52,0,0,0,.578-4.987,21.462,21.462,0,0,0-.771-5.737,19.942,19.942,0,0,0-.917-2.606c-.035-.083-.071-.164-.11-.247h0v0c-.088-.2-.178-.389-.271-.581-.046-.1-.094-.193-.143-.288-.095-.19-.195-.375-.3-.56a17.919,17.919,0,0,0-1.921-2.827q-.274-.332-.561-.645a11.23,11.23,0,0,0,1.4-5.489,11.423,11.423,0,0,0-.064-1.223h-2.217a2.676,2.676,0,0,0-2.4,2.869v84.142a2.675,2.675,0,0,0,2.4,2.868h135.684a2.586,2.586,0,0,0,2.372-2.392v-2.4C-540.4-589.88-545.613-595.507-551.932-595.507Z",
    transform: "translate(680.075 667.688)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17321",
    "data-name": "Group 17321",
    transform: "translate(22.676 21.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21215",
    "data-name": "Path 21215",
    d: "M-639.1-638.595a3.065,3.065,0,0,1-1.016,3.889,2.4,2.4,0,0,1-3.446-1.147,3.065,3.065,0,0,1,1.017-3.888A2.4,2.4,0,0,1-639.1-638.595Z",
    transform: "translate(643.869 640.091)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21216",
    "data-name": "Path 21216",
    d: "M-638.508-638.777a2.223,2.223,0,0,1-.737,2.821,1.741,1.741,0,0,1-2.5-.832,2.224,2.224,0,0,1,.738-2.822A1.741,1.741,0,0,1-638.508-638.777Z",
    transform: "translate(643.16 640.024)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17322",
    "data-name": "Group 17322",
    transform: "translate(72.483 44.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21217",
    "data-name": "Path 21217",
    d: "M-561.349-607.384a1.924,1.924,0,0,1-.638,2.441,1.507,1.507,0,0,1-2.164-.72,1.925,1.925,0,0,1,.638-2.442A1.506,1.506,0,0,1-561.349-607.384Z",
    transform: "translate(564.345 608.324)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21218",
    "data-name": "Path 21218",
    d: "M-560.979-607.5a1.4,1.4,0,0,1-.463,1.772,1.093,1.093,0,0,1-1.57-.523,1.4,1.4,0,0,1,.463-1.772A1.093,1.093,0,0,1-560.979-607.5Z",
    transform: "translate(563.9 608.282)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17323",
    "data-name": "Group 17323",
    transform: "translate(43.047 17.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21219",
    "data-name": "Path 21219",
    d: "M-609.746-645.256a1.026,1.026,0,0,1-.34,1.3.8.8,0,0,1-1.155-.384,1.027,1.027,0,0,1,.341-1.3A.8.8,0,0,1-609.746-645.256Z",
    transform: "translate(611.345 645.758)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21220",
    "data-name": "Path 21220",
    d: "M-609.548-645.317a.745.745,0,0,1-.247.946.583.583,0,0,1-.838-.279.745.745,0,0,1,.247-.946A.584.584,0,0,1-609.548-645.317Z",
    transform: "translate(611.107 645.735)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17324",
    "data-name": "Group 17324",
    transform: "translate(34.252 9.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21221",
    "data-name": "Path 21221",
    d: "M-623.1-624.4l1.335-15.6-2.422,7.242,1.239-25.364-2.443,30.318,2.351-5.365Z",
    transform: "translate(625.387 658.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21222",
    "data-name": "Path 21222",
    d: "M-588.444-605.143l9.979-10.906-6,3.744,15.511-18.41-19.273,21.3,4.872-2.366Z",
    transform: "translate(611.582 650.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "spaceship-2",
    "data-name": "spaceship",
    transform: "translate(64.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17326",
    "data-name": "Group 17326",
    transform: "translate(0 53.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21223",
    "data-name": "Path 21223",
    d: "M-552.225-673c-5.709,2.467-9.614,3.38-19.951,11.108-.023.016-.045.033-.068.052l.045-.073c6.9-10.887,7.5-14.839,9.51-20.706,2.018-5.894,8.593-9.28,8.593-9.28l5.585,4.407.022.021,4.857,5.192S-546.491-675.476-552.225-673Z",
    transform: "translate(572.244 691.898)",
    fill: "#f68e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21224",
    "data-name": "Path 21224",
    d: "M-558.847-668.89a64.45,64.45,0,0,0,3.371-8.834c.283-.883.575-1.795.9-2.736,1.06-3.094,5.368-6.942,7.135-8.166l3.547,3.261,3.647,3.353c-1.079,1.852-4.344,6.65-7.365,7.955-.915.4-1.8.758-2.664,1.11A64.932,64.932,0,0,0-558.847-668.89Z",
    transform: "translate(566.649 690.524)",
    fill: "#f1bc03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21225",
    "data-name": "Path 21225",
    d: "M-551.233-672.749c.579-1.377,1.082-2.67,1.578-3.945l.006-.016c.381-.977.774-1.988,1.2-3.019.795-1.94,3.475-4.789,5.585-6.684l4.436,4.079c-1.8,2.5-4.286,5.379-6.043,6.263-1,.5-1.981.976-2.929,1.433l-.011.005C-548.65-674.038-549.9-673.435-551.233-672.749Z",
    transform: "translate(563.469 689.596)",
    fill: "#faf8a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17327",
    "data-name": "Group 17327",
    transform: "translate(4.704 20.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21226",
    "data-name": "Path 21226",
    d: "M-544.6-731.674a10.972,10.972,0,0,0-4.079.6c-6.835,2.229-13.692,9.732-13.692,9.732l0,0c-.1-.162-4.23-6.907.391-15.9a21.534,21.534,0,0,1,10.115-9.243,1.456,1.456,0,0,1,1.659.237,1.567,1.567,0,0,1,.508,1.077,1.459,1.459,0,0,1-.411,1.062l10.1-3.284,7.564-2.459,0,0C-535.874-741.144-544.6-731.674-544.6-731.674Z",
    transform: "translate(564.167 749.853)",
    fill: "#dc3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21227",
    "data-name": "Path 21227",
    d: "M-562.373-719.022c-.1-.162-4.23-6.907.391-15.9a21.534,21.534,0,0,1,10.115-9.243,1.456,1.456,0,0,1,1.659.237,1.567,1.567,0,0,1,.508,1.077q-.186.51-.411,1.062s-7.351,4.068-10.542,11.384C-563.793-723.2-562.416-719.147-562.373-719.022Z",
    transform: "translate(564.167 747.531)",
    fill: "#ef4c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21228",
    "data-name": "Path 21228",
    d: "M-533.493-731.674a10.972,10.972,0,0,0-4.079.6c1.578-6.207,5.275-12,8.672-16.319l7.564-2.459,0,0C-524.767-741.144-533.493-731.674-533.493-731.674Z",
    transform: "translate(553.06 749.853)",
    fill: "#be292c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17328",
    "data-name": "Group 17328",
    transform: "translate(34.667 42.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21229",
    "data-name": "Path 21229",
    d: "M-503.806-697.728a10.859,10.859,0,0,1-.274,4.1c-1.681,6.967-8.636,14.379-8.636,14.379h0c.17.088,7.249,3.647,15.872-1.665a21.485,21.485,0,0,0,8.434-10.788,1.443,1.443,0,0,0-.37-1.629,1.579,1.579,0,0,0-1.118-.418,1.475,1.475,0,0,0-1.03.493l2.474-10.3,1.853-7.71v0C-495.033-707.156-503.806-697.728-503.806-697.728Z",
    transform: "translate(512.715 711.265)",
    fill: "#dc3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21230",
    "data-name": "Path 21230",
    d: "M-512.71-666.578c.17.088,7.249,3.647,15.872-1.665a21.486,21.486,0,0,0,8.434-10.788,1.443,1.443,0,0,0-.37-1.629,1.579,1.579,0,0,0-1.118-.418q-.5.226-1.03.493s-3.478,7.627-10.542,11.384C-508.417-665.5-512.582-666.545-512.71-666.578Z",
    transform: "translate(512.713 698.594)",
    fill: "#ef4c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21231",
    "data-name": "Path 21231",
    d: "M-497.612-697.728a10.858,10.858,0,0,1-.274,4.1c6.084-2.066,11.579-6.2,15.629-9.924l1.853-7.71v0C-488.84-707.156-497.612-697.728-497.612-697.728Z",
    transform: "translate(506.522 711.265)",
    fill: "#be292c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21232",
    "data-name": "Path 21232",
    d: "M-499.633-741.237a78.634,78.634,0,0,1-5.973,5.964,46.736,46.736,0,0,1-6.678,4.813c-.086.053-.174.1-.263.148l-4.5,2.337-4.972,2.581-9.459,4.911-10.66-9.8.472-1.111,3.682-8.677,2.183-5.145a62.865,62.865,0,0,1,11.451-17.905c.138-.15.278-.3.418-.454a69.529,69.529,0,0,1,19.579-15.042q.653-.33,1.293-.635,1.538-.732,3.007-1.331.633-.259,1.249-.495c.21-.081.418-.159.625-.235a53.261,53.261,0,0,1,7.213-2.111,44.005,44.005,0,0,1,6.044-.892,2.614,2.614,0,0,1,2.9,2.671,48.614,48.614,0,0,1-1.939,13.408c-.066.233-.135.467-.2.7q-.185.629-.394,1.275-.484,1.5-1.093,3.086-.246.642-.517,1.3A69.281,69.281,0,0,1-499.633-741.237Z",
    transform: "translate(559.67 784.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21233",
    "data-name": "Path 21233",
    d: "M-526.532-687.658l-4.945,2.568q-.861-.446-1.678-.931-.691-.411-1.349-.854a25.834,25.834,0,0,1-4.242-3.529,23.282,23.282,0,0,1-3.391-4.488l2.172-5.118a36.572,36.572,0,0,0,4.391,5.56,35.412,35.412,0,0,0,6.4,5.245q.587.378,1.194.735Q-527.267-688.049-526.532-687.658Z",
    transform: "translate(559.67 748.932)",
    fill: "#182632"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21234",
    "data-name": "Path 21234",
    d: "M-538.746-725.144a23.285,23.285,0,0,1-3.391-4.488l2.172-5.118,1.982-4.67,2.183-5.145A62.864,62.864,0,0,1-524.35-762.47c.138-.15.278-.3.418-.454,9.058-9.782,18.285-14.981,25.753-17.739a53.252,53.252,0,0,1,7.213-2.111c.4,1.9,1.22,2.088-1.059,5.334,0,0-21.346,6.508-31.5,21.917-9.3,14.115-2.983,14.774-2.983,14.774l-9.068,11.56Z",
    transform: "translate(559.67 783.674)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17329",
    "data-name": "Group 17329",
    transform: "translate(17.396 30.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21235",
    "data-name": "Path 21235",
    d: "M-541.138-697.5a.848.848,0,0,1-.957-.139.84.84,0,0,1-.216-.939c5.327-13.451,22.948-27.406,30.347-32.83a.835.835,0,0,1,1.085.059.828.828,0,0,1,.146,1.073C-515.564-722.492-528.11-703.871-541.138-697.5Z",
    transform: "translate(542.372 731.58)",
    fill: "#dc3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21236",
    "data-name": "Path 21236",
    d: "M-510.878-731.349l-31.216,33.71a.84.84,0,0,1-.216-.939c5.327-13.451,22.948-27.406,30.347-32.83A.835.835,0,0,1-510.878-731.349Z",
    transform: "translate(542.372 731.58)",
    fill: "#be292c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17331",
    "data-name": "Group 17331",
    transform: "translate(48.989 13.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17330",
    "data-name": "Group 17330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21237",
    "data-name": "Path 21237",
    d: "M-474.035-746.843a8.14,8.14,0,0,1-11.472.46,8.069,8.069,0,0,1-.462-11.431,8.139,8.139,0,0,1,11.472-.46A8.069,8.069,0,0,1-474.035-746.843Z",
    transform: "translate(488.121 760.418)",
    fill: "#182632"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21238",
    "data-name": "Path 21238",
    d: "M-474.063-746.764l-.059.062a6.443,6.443,0,0,1-8.951.359c-.022-.018-.043-.038-.064-.056a6.41,6.41,0,0,1-1.118-1.353,6.387,6.387,0,0,1-.929-2.9,6.381,6.381,0,0,1,.347-2.577,6.368,6.368,0,0,1,1.335-2.21,6.444,6.444,0,0,1,9.074-.363,6.353,6.353,0,0,1,1.509,2.1,6.385,6.385,0,0,1,.554,2.541,6.378,6.378,0,0,1-.693,2.965A6.381,6.381,0,0,1-474.063-746.764Z",
    transform: "translate(486.901 759.192)",
    fill: "#33c8cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21239",
    "data-name": "Path 21239",
    d: "M-472.083-748.2a6.378,6.378,0,0,0,.693-2.965,6.384,6.384,0,0,0-.554-2.541,6.353,6.353,0,0,0-1.509-2.1,6.444,6.444,0,0,0-9.074.363c-.12.13-.233.262-.339.4a6.447,6.447,0,0,1,8.7.011,6.36,6.36,0,0,1,1.51,2.1,6.384,6.384,0,0,1,.554,2.541,6.377,6.377,0,0,1-.693,2.965,6.3,6.3,0,0,1-.665,1.037c.109-.1.215-.2.317-.311l.059-.062A6.38,6.38,0,0,0-472.083-748.2Z",
    transform: "translate(485.926 759.192)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21240",
    "data-name": "Path 21240",
    d: "M-473.392-749.442s.134,3.651-2.466,5.308c-2.847,1.814-5.259.342-6.857-2.264a4.974,4.974,0,0,0,3.69,4.087C-475.39-741.143-471.934-745-473.392-749.442Z",
    transform: "translate(485.863 755.81)",
    fill: "#00eeed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17332",
    "data-name": "Group 17332",
    transform: "translate(61.491 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21241",
    "data-name": "Path 21241",
    d: "M-452.43-768.239a56,56,0,0,1-14.223-13.075,49.073,49.073,0,0,1,13.257-3,2.652,2.652,0,0,1,2.374,1.02,2.761,2.761,0,0,1,.531,1.651A48.609,48.609,0,0,1-452.43-768.239Z",
    transform: "translate(466.653 784.326)",
    fill: "#dc3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21242",
    "data-name": "Path 21242",
    d: "M-443.14-776.465c.045-.538.131-.905.228-1.74.151-1.3-.094-1.843-.979-1.827-1.61.03-3.284,6.612-1.462,9.053C-443.936-769.08-443.337-774.128-443.14-776.465Z",
    transform: "translate(458.088 782.524)",
    fill: "#ef4c65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21243",
    "data-name": "Path 21243",
    d: "M-452.43-768.239a56,56,0,0,1-14.223-13.075,49.073,49.073,0,0,1,13.257-3,2.652,2.652,0,0,1,2.374,1.02c-.565-.012-4.632,0-6.865,2.406C-460.291-778.3-459.032-772.943-452.43-768.239Z",
    transform: "translate(466.653 784.326)",
    opacity: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0 90.839)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21299",
    "data-name": "Path 21299",
    d: "M1365.271,2324.853v29.515a2.026,2.026,0,0,1-2.023,2.016h-28.476v-33.547h28.476A2.027,2.027,0,0,1,1365.271,2324.853Z",
    transform: "translate(-1281.143 -2320.525)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21300",
    "data-name": "Path 21300",
    d: "M1511,2332.285l.146,33.547h-19.614a2.027,2.027,0,0,1-2.023-2.016V2334.3a2.026,2.026,0,0,1,2.023-2.016Z",
    transform: "translate(-1308.622 -2322.232)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "user_-_r",
    "data-name": "user - r",
    transform: "translate(177.972 6.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17421",
    "data-name": "Group 17421",
    transform: "translate(49.267 4.097)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M387.107,308.038s1.786-8.9,9.578-5.176,1.461,15.2,6.818,16.175,8.118.647,7.955,4.529-14.124,8.735-16.722,0,1.3-16.013-2.435-16.337a4.236,4.236,0,0,0-4.545,3.234Z",
    transform: "translate(-350.603 -301.952)",
    fill: "#1a2e35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M380.891,303.537s6.182-.039,7.015,5.086a5.942,5.942,0,0,1-3.061,6.536Z",
    transform: "translate(-348.914 -302.387)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 1.11)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(37.212 79.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M392.993,413.7l2.517,18.833,3.022-.022-2.424-18.714Z",
    transform: "translate(-389.415 -413.697)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M393.8,439.649l-2.367.018c-1.352.009-2.838.472-3.182,2.09l-.169,1.063,9.409-.07a4.017,4.017,0,0,0-.269-3.126Z",
    transform: "translate(-388.08 -420.813)",
    fill: "#00468d"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(17.118 78.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M367.616,411.207l.9,18.846,3.022-.022L370.73,411.3Z",
    transform: "translate(-362.423 -411.207)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M366.2,437.176l-2.367.017c-1.352.01-2.838.472-3.183,2.09l-.169,1.063,9.409-.07a4.014,4.014,0,0,0-.269-3.126Z",
    transform: "translate(-360.484 -418.328)",
    fill: "#00468d"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M373.135,328.982l-7.329.033-.179,5.22,8.182,1.593Z",
    transform: "translate(-344.764 -310.482)",
    fill: "#234599"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M363.017,328.834l-7.161-.515-.488,4.794,7.469.942Z",
    transform: "translate(-341.976 -310.3)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M352.275,325.326l-8.457-7.909-1.626,2.274,9.595,10.429Z",
    transform: "translate(-338.394 -307.308)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M398.365,366.324a2.925,2.925,0,1,1-1.185-3.953A2.933,2.933,0,0,1,398.365,366.324Z",
    transform: "translate(-352.167 -319.55)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M342.481,317.725a2.925,2.925,0,1,1-1.185-3.953A2.934,2.934,0,0,1,342.481,317.725Z",
    transform: "translate(-336.976 -306.211)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M390.42,329.094a9.063,9.063,0,0,1,5.685,2.563l4.017,3.646-2.87,3.867-6.7-5.42Z",
    transform: "translate(-351.504 -310.513)",
    fill: "#2e4cac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M398.984,341.519l3.588,2.777L396.8,356.239l1.705,1.636,8.52-13.925a1.722,1.722,0,0,0-.409-2.054l-4.759-4.244Z",
    transform: "translate(-353.237 -312.861)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M372.319,330.832l3.693,17.482,9.423-.268,1.775-17.167a1.727,1.727,0,0,0-1.716-1.819l-11.571-.089A1.608,1.608,0,0,0,372.319,330.832Z",
    transform: "translate(-346.578 -310.479)",
    fill: "#2e4cac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M381.874,328.306l-.39-.036a1.908,1.908,0,0,1-1.731-2.05l.583-7.2,4.2.386-.579,7.154A1.91,1.91,0,0,1,381.874,328.306Z",
    transform: "translate(-348.603 -307.748)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    d: "M0,0H11.212a0,0,0,0,1,0,0V6.518A5.608,5.608,0,0,1,5.6,12.126h0A5.6,5.6,0,0,1,0,6.521V0A0,0,0,0,1,0,0Z",
    transform: "translate(25.774 4.222) rotate(4.464)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M383.015,312.79l-1.334,1.724s-1.462.807-1.245-1.949c.184-2.335-1.555-1.741-1.555-1.741s-7.253,2.379-9.245-.554c-2.464-3.628,3.668-7.2,8.042-6.749l5.79,4.115Z",
    transform: "translate(-345.701 -303.483)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M385.48,317.974a1.839,1.839,0,1,0,1.993-1.666A1.835,1.835,0,0,0,385.48,317.974Z",
    transform: "translate(-350.159 -307.001)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M387.424,320.067a.331.331,0,1,0,.359-.3A.331.331,0,0,0,387.424,320.067Z",
    transform: "translate(-350.689 -307.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(26.046 9.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M378.741,316.914a.511.511,0,1,1-.487-.519A.5.5,0,0,1,378.741,316.914Z",
    transform: "translate(-374.097 -316.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M373.767,316.821a.511.511,0,1,1-.488-.519A.5.5,0,0,1,373.767,316.821Z",
    transform: "translate(-372.745 -316.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M374.992,317.831l-1.026.974a.182.182,0,0,0,.137.3l1.078.04-.189-1.314Z",
    transform: "translate(-373.065 -316.721)",
    fill: "#caa896"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M373.447,320.784l4.35.151s-.24,1.733-2.589,1.563A1.93,1.93,0,0,1,373.447,320.784Z",
    transform: "translate(-346.89 -308.232)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(19.536 37.567)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M377.4,355.631",
    transform: "translate(-367.501 -355.363)",
    fill: "#40435b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M383.182,358.485l-9.479-2.854-.068,1.861-9.588,28.149a4.232,4.232,0,0,0-.087,2.542l2.739,24.334,4.226.018-.78-25.988Z",
    transform: "translate(-363.806 -355.363)",
    fill: "#acbee2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M387.5,355.262l-7.608.313,11.121,58.947,4.27-.11-4.764-46.656A10.83,10.83,0,0,0,387.5,355.262Z",
    transform: "translate(-368.178 -355.262)",
    fill: "#d1defe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M377.4,355.529l9.423-.268-7.777,3.822Z",
    transform: "translate(-367.501 -355.262)",
    fill: "#acbee2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M375.828,372.384l2.383,3.052-5.7,15.709,7.379-15.167-.322-3.373Z",
    transform: "translate(-366.173 -359.961)",
    fill: "#c6c6c6",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17372",
    "data-name": "Group 17372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17370",
    "data-name": "Group 17370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17228",
    "data-name": "Rectangle 17228",
    d: "M2.461,0H50.221a2.46,2.46,0,0,1,2.46,2.46V31.086a2.461,2.461,0,0,1-2.461,2.461H2.461A2.461,2.461,0,0,1,0,31.086V2.461A2.461,2.461,0,0,1,2.461,0Z",
    transform: "translate(0 0.599)",
    fill: "#d4defe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17229",
    "data-name": "Rectangle 17229",
    d: "M2.461,0H50.221a2.46,2.46,0,0,1,2.46,2.46V31.086a2.461,2.461,0,0,1-2.461,2.461H2.461A2.461,2.461,0,0,1,0,31.086V2.461A2.461,2.461,0,0,1,2.461,0Z",
    fill: "#feffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17371",
    "data-name": "Group 17371",
    transform: "translate(2.918 2.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21303",
    "data-name": "Path 21303",
    d: "M1492.382,2332.55a1.435,1.435,0,1,1-1.435-1.429A1.433,1.433,0,0,1,1492.382,2332.55Z",
    transform: "translate(-1489.512 -2331.12)",
    fill: "#d9e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21304",
    "data-name": "Path 21304",
    d: "M1497.708,2332.55a1.435,1.435,0,1,1-1.435-1.429A1.433,1.433,0,0,1,1497.708,2332.55Z",
    transform: "translate(-1490.458 -2331.12)",
    fill: "#d9e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21305",
    "data-name": "Path 21305",
    d: "M1503.124,2332.55a1.435,1.435,0,1,1-1.435-1.429A1.434,1.434,0,0,1,1503.124,2332.55Z",
    transform: "translate(-1491.42 -2331.12)",
    fill: "#d9e8ff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17230",
    "data-name": "Rectangle 17230",
    width: 46.09,
    height: 11.646,
    rx: 1.18,
    transform: "translate(2.918 8.492)",
    fill: "#5d8edf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17231",
    "data-name": "Rectangle 17231",
    width: 46.09,
    height: 1.802,
    transform: "translate(2.918 22.519)",
    fill: "#d9e8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17232",
    "data-name": "Rectangle 17232",
    width: 46.09,
    height: 1.802,
    transform: "translate(2.918 26.702)",
    fill: "#d9e8ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "user_-_l",
    "data-name": "user - l"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-2",
    "data-name": "user",
    transform: "translate(0 2.624)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M107.933,341.336c.072-.01.144-.023.216-.038l16.722-3.665-1.2-5.445-14.98,3.284a117.841,117.841,0,0,0-8.3-9.358c.038.065-.155.253,0,0l-5.287.915c-.145,1.358,1.028,1.287,10.222,13.242A2.8,2.8,0,0,0,107.933,341.336Z",
    transform: "translate(-80.085 -305.794)",
    fill: "#4a75cb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M97.285,360.316l1.984,6.066-18.64,2.289.1-7.78Z",
    transform: "translate(-76.337 -314.746)",
    fill: "#163560"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M93.109,366.436l10.02,17.4-1.88,22.375,6.652.779,3.02-24.114-8.961-16.554Z",
    transform: "translate(-79.57 -316.317)",
    fill: "#1c468a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M95.094,369.6l3.772-.622L97.12,373.2Z",
    transform: "translate(-80.085 -317.014)",
    fill: "#c6c6c6",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M79.4,369.053l-.065,17.276-3.287,28.732,6.664.892,4.344-29.377.817-19.977Z",
    transform: "translate(-75.149 -316.391)",
    fill: "#1c468a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M104.4,429l.669-5.135,3.6.425-.194,2.322,4.936,1.251a1.831,1.831,0,0,1,1.226,1.794l-.094.794-10.239-.657Z",
    transform: "translate(-82.471 -331.379)",
    fill: "#222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M76.981,437.516l.385-5.163,3.62.227-.066,2.329,4.988,1.488a1.835,1.835,0,0,1,1.323,1.725l-.05.8-10.25-.6Z",
    transform: "translate(-75.379 -333.602)",
    fill: "#222"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M86.737,325.049l-.544.128a6.1,6.1,0,0,0-4.621,4.9l-2.344,22.209c8.531,3.9,18.628-1.235,18.628-1.235l.578-20.6A5.353,5.353,0,0,0,95.11,325.2h0Z",
    transform: "translate(-75.975 -305.515)",
    fill: "#739af0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 2.904,
    height: 8.349,
    transform: "translate(20.638 92.376) rotate(-83.636)",
    fill: "#1c468a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 2.905,
    height: 8.349,
    transform: "translate(0 98.806) rotate(-82.86)",
    fill: "#1c468a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M99.4,348.991l-4.966.351a3.833,3.833,0,0,1-3.371-1.97L84.678,335.3c2.644,7.118,5.973,14.322,5.973,14.322a2.331,2.331,0,0,0,2.373,1.366l6.342-.692Z",
    transform: "translate(-77.386 -308.197)",
    fill: "#e0e0e0",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(8.362 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17509",
    "data-name": "Group 17509",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21511",
    "data-name": "Path 21511",
    d: "M889.847,2565.973c-.063-.313.038-.335.118-.333a.515.515,0,0,1,.306.342,5.632,5.632,0,0,0,1.472,1.544c.081.058.159.117.245.173a4.733,4.733,0,0,0,2.414.792c-.016.086-.032.172-.045.257-.032.2-.054.4-.068.6a2.954,2.954,0,0,0,1.72,3.2c.005.081.2.166.266.224a2.9,2.9,0,0,1,.975,1.857c0,.532-.5.951-1.089,1.457l-.828.552-1.122-.107a7.756,7.756,0,0,1-4.978-4.376C890.126,2570.7,890.114,2568.171,889.847,2565.973Z",
    transform: "translate(-885.541 -2552.295)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21512",
    "data-name": "Path 21512",
    d: "M896.229,2572.625c-.016.086-.032.171-.045.258.013-.086.029-.172.045-.258Z",
    transform: "translate(-887.367 -2556.43)",
    fill: "#913c38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21513",
    "data-name": "Path 21513",
    d: "M896.185,2570.26c.081.058.159.117.245.173a4.732,4.732,0,0,0,2.415.792c-.016.086-.032.171-.045.258-.032.2-.054.4-.068.6,0,.011,0,.023,0,.035A4.126,4.126,0,0,1,896.185,2570.26Z",
    transform: "translate(-889.983 -2555.03)",
    fill: "#913c38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21514",
    "data-name": "Path 21514",
    d: "M896.185,2570.26c.081.058.159.117.245.173a4.732,4.732,0,0,0,2.415.792c-.016.086-.032.171-.045.258-.032.2-.054.4-.068.6,0,.011,0,.023,0,.035A4.126,4.126,0,0,1,896.185,2570.26Z",
    transform: "translate(-889.983 -2555.03)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21515",
    "data-name": "Path 21515",
    d: "M887.609,2543.1a7.56,7.56,0,0,0-1.5-1.928,2.956,2.956,0,0,0,.694-.714c.645.3,1.255,1.156,1.571,3.064a4.885,4.885,0,0,1,.034,1.366c-.124-.359-.265-.713-.424-1.058Z",
    transform: "translate(-875.447 -2537.388)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21516",
    "data-name": "Path 21516",
    d: "M885.453,2547.617a3.785,3.785,0,0,1,.408-5.457c-.2-2.849,3.914-3.222,5.7-1.481a7.568,7.568,0,0,1,1.5,1.928l.372.73c.159.345.3.7.423,1.058a12.487,12.487,0,0,1,.7,4.011,4.674,4.674,0,0,1-4.792,4.687h0a4.728,4.728,0,0,1-2.414-.792c-.086-.055-.165-.115-.245-.173a5.628,5.628,0,0,1-1.472-1.543C884.713,2549.119,884.954,2548.381,885.453,2547.617Z",
    transform: "translate(-880.904 -2536.899)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21517",
    "data-name": "Path 21517",
    d: "M888.145,2547.127a.166.166,0,0,1-.224.243.157.157,0,0,1-.04-.031,1.418,1.418,0,0,0-1.12-.561.171.171,0,0,1-.18-.157.168.168,0,0,1,.157-.179,1.7,1.7,0,0,1,.811.2A1.834,1.834,0,0,1,888.145,2547.127Z",
    transform: "translate(-875.386 -2540.931)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21518",
    "data-name": "Path 21518",
    d: "M892,2560.076a.085.085,0,0,1,.12,0,2.394,2.394,0,0,0,2.036.506.085.085,0,1,1,.034.166,2.78,2.78,0,0,1-.593.054,2.469,2.469,0,0,1-1.6-.6A.084.084,0,0,1,892,2560.076Z",
    transform: "translate(-883.671 -2548.987)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21519",
    "data-name": "Path 21519",
    d: "M887.41,2552.97a10.776,10.776,0,0,0,1.919,2.127,1.643,1.643,0,0,1-1.293.519Z",
    transform: "translate(-876.873 -2544.796)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21520",
    "data-name": "Path 21520",
    d: "M888.48,2551.735c-.185.037-.389-.161-.455-.441s.03-.537.215-.574.389.161.455.441S888.665,2551.7,888.48,2551.735Z",
    transform: "translate(-876.503 -2543.462)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21521",
    "data-name": "Path 21521",
    d: "M896.293,2553.291c-.185.037-.389-.16-.455-.441s.03-.536.215-.573.389.16.455.441S896.478,2553.255,896.293,2553.291Z",
    transform: "translate(-887.516 -2544.383)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21522",
    "data-name": "Path 21522",
    d: "M908.941,2544.682c.112.007.238.01.374.011a7.6,7.6,0,0,1,.486,1.773,4.707,4.707,0,0,1-.895,3.683c-.84,1.422-1.915,1.382-2.847.3-1.5-1.435-2.945-4.3.038-6.542A4.913,4.913,0,0,0,908.941,2544.682Z",
    transform: "translate(-904.358 -2539.431)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21523",
    "data-name": "Path 21523",
    d: "M904.738,2557.732a2.114,2.114,0,0,1,2.052.541,4.061,4.061,0,0,1,.844.926c.58.9.374,1.952-.663,2.042a1.63,1.63,0,0,1-.179.007c-.08,0-.163-.008-.245-.016a3.548,3.548,0,0,1-2.16-1.021,1.647,1.647,0,0,1-.444-1.64A1.334,1.334,0,0,1,904.738,2557.732Z",
    transform: "translate(-902.241 -2547.555)",
    fill: "#f7ad7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21524",
    "data-name": "Path 21524",
    d: "M898.586,2536.721c-1.5,1.124-4.226,1.488-5.7,1.481-.136,0-.262,0-.374-.01a4.913,4.913,0,0,1-2.843-.777c-1.731-1.476,2.215-4.475,2.215-4.475s-.44,1.076.478,1.373,7.387-2.1,7.276.62a2.056,2.056,0,0,1-.356,1.074A2.971,2.971,0,0,1,898.586,2536.721Z",
    transform: "translate(-887.927 -2532.941)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21525",
    "data-name": "Path 21525",
    d: "M898.787,2549.082a1.292,1.292,0,0,0-.932.757.169.169,0,0,1-.308-.14,1.63,1.63,0,0,1,1.2-.952.169.169,0,1,1,.043.335Z",
    transform: "translate(-890.625 -2542.296)",
    fill: "#1a2e35"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(6.402 21.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(25.328 11.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M121.924,347a2.8,2.8,0,1,0,2.392-3.152A2.8,2.8,0,0,0,121.924,347Z",
    transform: "translate(-118.758 -343.824)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M119.237,349.222l2.889-.4a1.385,1.385,0,0,0,1.182-1.557h0a1.389,1.389,0,0,0-1.563-1.178l-2.889.4a1.385,1.385,0,0,0-1.182,1.557h0A1.389,1.389,0,0,0,119.237,349.222Z",
    transform: "translate(-117.66 -344.413)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M110.669,346.334l-.394-5.562-15.383,1.083-6.157-12.136a2.8,2.8,0,0,0-3.793-1.121h0a2.783,2.783,0,0,0-1.125,3.78l7.016,13.715a2.8,2.8,0,0,0,2.656,1.452Z",
    transform: "translate(-83.477 -328.26)",
    fill: "#4a75cb"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17400",
    "data-name": "Group 17400",
    transform: "translate(29.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17396",
    "data-name": "Group 17396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17395",
    "data-name": "Group 17395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17393",
    "data-name": "Group 17393"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17234",
    "data-name": "Rectangle 17234",
    width: 52.682,
    height: 33.546,
    rx: 2.461,
    transform: "translate(0 0.599)",
    fill: "#d4defe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17235",
    "data-name": "Rectangle 17235",
    width: 52.682,
    height: 33.546,
    rx: 2.461,
    fill: "#feffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17394",
    "data-name": "Group 17394",
    transform: "translate(2.918 2.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21339",
    "data-name": "Path 21339",
    d: "M1311.914,2324.388a1.435,1.435,0,1,1-1.435-1.43A1.432,1.432,0,0,1,1311.914,2324.388Z",
    transform: "translate(-1309.044 -2322.958)",
    fill: "#d9e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21340",
    "data-name": "Path 21340",
    d: "M1317.24,2324.388a1.435,1.435,0,1,1-1.435-1.43A1.433,1.433,0,0,1,1317.24,2324.388Z",
    transform: "translate(-1309.99 -2322.958)",
    fill: "#d9e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21341",
    "data-name": "Path 21341",
    d: "M1322.656,2324.388a1.436,1.436,0,1,1-1.435-1.43A1.433,1.433,0,0,1,1322.656,2324.388Z",
    transform: "translate(-1310.951 -2322.958)",
    fill: "#d9e8ff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17236",
    "data-name": "Rectangle 17236",
    width: 45.452,
    height: 1.802,
    transform: "translate(3.297 10.087)",
    fill: "#d9e8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17237",
    "data-name": "Rectangle 17237",
    width: 45.452,
    height: 1.802,
    transform: "translate(3.297 14.271)",
    fill: "#d9e8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17238",
    "data-name": "Rectangle 17238",
    width: 14.597,
    height: 1.802,
    transform: "translate(3.297 18.652)",
    fill: "#d9e8ff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadViewIllustration);
export default __webpack_public_path__ + "static/media/downloadViewIllustration.f80ad5f72f7e090e2bfb3203ca0dbf4e.svg";
export { ForwardRef as ReactComponent };